/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  host: 'host_73ccc275',
};

export = styles;

loadStyles([{"rawString":".host_73ccc275{display:inline}"}]);
/* tslint:enable */